import HippaSRC from "assets/images/icons/hippa-primary.svg";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isAuthenticatedSelector } from "store/auth";
import { isOpenedInIframe } from "utils/helpers";
import Footer, { FooterCopyRights, FooterStaticPages } from "views/components/Footer";
import LocaleNavLink from "views/components/LocaleNavLink";
import SocialNav from "views/components/SocialNav";
import { default as KeepInTouchSection } from "views/sections/KeepInTouch";

const RootFooter = ({ type }) => {
	const { t } = useTranslation();

	// redux global state
	const isAuthenticated = useSelector(isAuthenticatedSelector);

	if (isOpenedInIframe()) return null;
	return (
		<Footer type={type}>
			<div className="container">
				{["home", "webinar"]?.includes(type) && (
					<div className="row gy-4 gy-lg-0 mt-0 align-items-end">
						<div className="col-12 mt-0">
							<hr className="border border-top-0 bg-transparent op-100 mt-0" />
						</div>
						<div className="col-12 col-lg-6 mt-4">
							<KeepInTouchSection />
						</div>
						<div className="col-12 col-lg-6">
							<div className="row gy-3 justify-content-end align-items-center">
								<div className="col-auto">
									<img
										src={HippaSRC}
										alt=""
										className="h-60px w-114px object-fit-contain"
										width="114"
										height="60"
										loading="lazy"
									/>
								</div>
								<div className="col-12">
									<div className="row gx-3 justify-content-end align-items-stretch">
										{!isAuthenticated && (
											<>
												<div className="col-auto">
													<LocaleNavLink
														to="/blog"
														className="btn btn-link nav-link link-primary-400 w-100 p-0 border-0 text-decoration-none text-uppercase h-100 d-inline-flex align-items-center">
														<small>
															<strong>{t("actions.blog")}</strong>
														</small>
													</LocaleNavLink>
												</div>
												<div className="col-auto">
													<div className="vr d-block h-100" aria-hidden="true"></div>
												</div>
												<div className="col-auto">
													<LocaleNavLink
														to="/careers"
														className="btn btn-link nav-link link-primary-400 w-100 p-0 border-0 text-decoration-none text-uppercase h-100 d-inline-flex align-items-center">
														<small>
															<strong>{t("actions.careers")}</strong>
														</small>
													</LocaleNavLink>
												</div>
												<div className="col-auto">
													<div className="vr d-block h-100" aria-hidden="true"></div>
												</div>
											</>
										)}
										<div className="col-auto">
											<SocialNav
												variant="primary"
												align="text-start text-lg-end"
												size="5"
												spacer="mx-2"
											/>
										</div>
									</div>
								</div>
								<div className="col-auto">
									<FooterCopyRights className="text-start text-lg-end" />
								</div>
								<div className="col-auto">
									<FooterStaticPages separator className="hstack gap-2 justify-content-lg-end" />
								</div>
							</div>
						</div>
					</div>
				)}
				{["auth", "note"]?.includes(type) && (
					<div className="row gy-3 gy-lg-0">
						<div className="col-12 col-lg-auto ms-lg-auto">
							<FooterStaticPages
								separator
								className="hstack gap-2 justify-content-center justify-content-lg-end"
							/>
						</div>
						<div className="col-12 col-lg order-lg-first">
							<FooterCopyRights className="text-lg-start" />
						</div>
					</div>
				)}
				{["static", "patient", "patient-intake", "demo", "order", "referral", "newsletter", "entry"]?.includes(
					type
				) && (
					<div
						className={`row justify-content-center ${
							["static"]?.includes(type)
								? "gy-5"
								: ![
										"patient",
										"patient-intake",
										"demo",
										"order",
										"referral",
										"newsletter",
										"entry",
								  ]?.includes(type)
								? "justify-content-md-start gy-4"
								: ""
						} mt-0`}>
						{!["patient", "patient-intake", "demo", "order", "referral", "newsletter", "entry"]?.includes(
							type
						) ? (
							<div className="col-12 mt-0">
								<hr className="border border-top-0 bg-transparent op-100 mt-0" />
							</div>
						) : (
							<></>
						)}
						<div className="col-auto">
							<div className={`row ${["static"]?.includes(type) ? "gy-4" : ""}`}>
								{!["patient", "patient-intake", "demo", "order", "referral"]?.includes(type) ? (
									<>
										<div className="col-12">
											<div className="row gx-3 justify-content-end align-items-stretch">
												<div className="col-auto">
													<LocaleNavLink
														to="/blog"
														className="btn btn-link nav-link link-primary-400 w-100 p-0 border-0 text-decoration-none text-uppercase h-100 d-inline-flex align-items-center">
														<small>
															<strong>{t("actions.blog")}</strong>
														</small>
													</LocaleNavLink>
												</div>
												<div className="col-auto">
													<div className="vr d-block h-100" aria-hidden="true"></div>
												</div>
												<div className="col-auto">
													<LocaleNavLink
														to="/careers"
														className="btn btn-link nav-link link-primary-400 w-100 p-0 border-0 text-decoration-none text-uppercase h-100 d-inline-flex align-items-center">
														<small>
															<strong>{t("actions.careers")}</strong>
														</small>
													</LocaleNavLink>
												</div>
												<div className="col-auto">
													<div className="vr d-block h-100" aria-hidden="true"></div>
												</div>
												<div className="col-auto">
													<SocialNav
														variant={
															![
																"entry",
																"patient-intake",
																"demo",
																"order",
																"referral",
																"newsletter",
															]?.includes(type)
																? "primary"
																: "white"
														}
														align="text-center"
														size={type === "static" ? "fs-5" : "fs-6"}
														spacer="mx-3"
													/>
												</div>
											</div>
										</div>
										{![
											"entry",
											"patient-intake",
											"demo",
											"order",
											"referral",
											"newsletter",
										]?.includes(type) ? (
											<div className="col-12">
												<FooterStaticPages
													separator
													className="hstack gap-2 justify-content-center"
												/>
											</div>
										) : (
											<></>
										)}
									</>
								) : (
									<></>
								)}
								<div className="col-12">
									<FooterCopyRights
										className={
											[
												"patient",
												"patient-intake",
												"demo",
												"order",
												"referral",
												"newsletter",
											]?.includes(type)
												? "text-white py-4"
												: ["entry"]?.includes(type)
												? "text-white pt-3 pb-2"
												: ""
										}
									/>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		</Footer>
	);
};

export default memo(RootFooter);
